export default {
  SET_LOADING: 'SET_LOADING',
  CLEAR_REPORTS: 'CLEAR_REPORTS',
  MELDUNG_ADD: 'MELDUNG_ADD',
  MELDUNG_REMOVE: 'MELDUNG_REMOVE',
  MARK_AS_READ: 'MARK_AS_READ',
  MARK_AS_DELETED: 'MARK_AS_DELETED',
  ADD_ORT: 'ADD_ORT',
  REMOVE_ORT: 'REMOVE_ORT',
  SET_ORT_ACTIVE: 'SET_ORT_ACTIVE',
  SET_ORT_RADIUS: 'SET_ORT_RADIUS',
  SET_ORT_CATEGORIES: 'SET_ORT_CATEGORIES',
  SET_ORT_COORDINATES: 'SET_ORT_COORDINATES',
  SET_ORT_SUBSCRIPTION_ID: 'SET_ORT_SUBSCRIPTION_ID',
  SET_ORT_AREA: 'SET_ORT_AREA',
};



// WEBPACK FOOTER //
// ./src/js/constants/actionTypes.js